import React, { useRef, useState, useEffect } from "react"
import {
  HelpCircle,
  Search,
  FileText,
  Book,
  FilePlus,
  BookOpen,
  Inbox,
} from "react-feather"
import { HashRouter as Router, Link } from "react-router-dom"
import Help from "../Help"
import MinFaq from "./MinFaq"
import Serchdata1 from "./search1.json"
import useOnClickOutside from "../commonfuction/useOnClickOutside"

const HelpDesk = () => {
  const [question, setQuestion] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [search, setSearch] = useState({
    searchString: "",
  })
  const clickOutSide = useRef(null)
  useOnClickOutside(clickOutSide, () => setShowModal(false))
  let onChangeSearchValue = e => {
    // let filterData = Searchdata.filter((data) =>
    //   data["title"]
    //     .toString()
    //     .toLowerCase()
    //     .includes(e.target.value.toLowerCase())
    // );

    const filterData = Serchdata1.map(item => ({
      ...item,
      children: item.children.filter(child =>
        child.title
          .toString()
          .toLowerCase()
          .includes(e.target.value.toLowerCase()),
      ),
    })).filter(item => item.children.length > 0)

    setQuestion(filterData)
    setSearch({ ...search, searchString: e.target.value })
    setShowModal(true)
  }

  const onClickShowSerch = value => {
    // setSearch({ ...search, searchString: value });
    // setQuestion([]);
    // setShowModal(false);
  }
  useEffect(() => {
    const listener = event => {
      if (event.key === "Escape") {
        setShowModal(false)
      }
    }

    window.addEventListener("keydown", listener)
    return () => {
      window.removeEventListener("keydown", listener)
    }
  }, [])
  return (
    <div className="heldesk">
      <div className="flex flex-col items-center main lg:px-16 md:px-8 sm:px-4 px-4  relative w-full">
        <div className="flex flex-col header items-center mb-24 mt-16 w-full z-0">
          <h1 className="text-3xl font-bold">
            Welcome! How can we help you today?
          </h1>
          <div ref={clickOutSide} className="max-w-xl mt-12 w-full relative">
            <div className="relative">
              <span className="absolute flex inset-y-0 items-center left-0 pl-4">
                <Search size="16" className="currentColor" />
              </span>
              <input
                onChange={e => onChangeSearchValue(e)}
                type="text"
                value={search.searchString}
                placeholder="Search..."
                className="border border-gray-400 focus:border-blue-600 focus:outline-none placeholder-gray-400 focus:outline-none focus:placeholder-gray-600 transition-all duration-300 ease-in-out pl-10 pr-4 py-3 rounded-full shadow-sm text-sm w-full"
              />
            </div>
            {showModal ? (
              <>
                {question.length > 0 ? (
                  <ul
                    className="w-full absolute bg-white border border-gray-400 mt-2 overflow-auto rounded-md shadow"
                    style={{ minHeight: "70px", maxHeight: "300px" }}
                  >
                    <Router>
                      {question.map((data, index) => (
                        <>
                          <li className="flex">
                            <div
                              className=" bg-gray-200  border-b border-gray-300 px-4 py-3 text-gray-600"
                              style={{
                                minWidth: "210px",
                                maxWidth: "210px",
                              }}
                            >
                              {data.name}
                            </div>

                            <div className="border-l">
                              {data.children.map((subData, index) => (
                                <Link
                                  to={`/onebill-faq/${data.name
                                    .split(/\s/)
                                    .join("")
                                    .toLowerCase()}`}
                                >
                                  <div className="text-sm text-gray-800 border-b border-gray-300  hover:bg-gray-100 last:border-b-0 px-4 py-3 ">
                                    {subData.title}
                                  </div>
                                </Link>
                              ))}
                            </div>
                          </li>
                        </>
                      ))}
                    </Router>
                  </ul>
                ) : (
                  <ul className="w-full absolute bg-white border border-gray-400 mt-2 rounded-md shadow">
                    <li className="px-4 py-3">
                      <div className="text-gray-800 text-sm font-medium">
                        No Question
                      </div>
                      <div className="text-gray-600 text-semibold">
                        Your search returned no results
                      </div>
                    </li>
                  </ul>
                )}
              </>
            ) : (
              ""
            )}
          </div>

          <h5 className="my-12 font-semibold">
            ... or choose a category to quickly find the help you need
          </h5>

          <div className="grid gap-8 lg:grid-cols-3 sm:grid-cols-2 max-w-screen-xl mx-auto">
            <Router>
              <Link
                to={`/onebill-Reference`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <FileText size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">Reference Guide</span>
                  <span className="mt-1 text-center text-gray-800 text-semibold text-sm">
                    The one stop location for quick links, shortcuts, and other
                    OneBill resource materials.
                  </span>
                </div>
              </Link>
            </Router>
            <Router>
              {/* <Link
                to={`/onebill-guides`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <Book size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">Guides</span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    Articles and resources to guide you
                  </span>
                </div>
              </Link> */}

              <Link
                to={`/onebill-faq`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <FileText size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">FAQs</span>
                  <span className="mt-1 text-center text-gray-800 text-semibold text-sm">
                    Frequently asked questions and answers
                  </span>
                </div>
              </Link>
            </Router>
            <Router>
              <Link
                to={`/onebill-support`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <HelpCircle size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">Support</span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    Contact us for more detailed support
                  </span>
                </div>
              </Link>
            </Router>
            {/* <Custom modules> */}
            <Router>
              <Link
                to={`/onebill-quickstart`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <FilePlus size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">Quickstart Guide</span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    To get started with the fundamentals of OneBill.
                  </span>
                </div>
              </Link>
            </Router>
            <Router>
              <Link
                to={`/home`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <BookOpen size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">
                    Product Documentation
                  </span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    For all screen, operations, use case, and platform related
                    information.
                  </span>
                </div>
              </Link>
            </Router>
            <Router>
              <Link
                to={`/onebill-api-reference`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <Book size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">
                    API Reference Guide
                  </span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    The complete guide to OneBill web services. References,
                    payloads, sample requests, and more
                  </span>
                </div>
              </Link>
            </Router>
            <Router>
              <Link
                to={`/onebill-training-guide`}
                className="nav-link rounded-lg h-48 bg-white flex flex-auto flex-col items-center justify-center p-5 shadow hover:shadow-xl transition-shadow duration-300 ease-in-out"
              >
                <Inbox size="40" className="text-red-600" />
                <div className="flex flex-col items-center">
                  <span className="mt-6 font-semibold">Training Guide</span>
                  <span className="mt-1 text-center text-gray-800 text-sm">
                    Contact us for more detailed support
                  </span>
                </div>
              </Link>
            </Router>
          </div>
        </div>
        <div className="faqs flex flex-col items-center w-full z-0 mb-12">
          <h2 className="font-bold text-3xl mb-2">
            Most frequently asked questions
          </h2>
          <h5 className="text-gray-700">
            Here are the most frequently asked questions you may check before
            getting started
          </h5>
        </div>
        <div className="mb-24">
          <MinFaq />
        </div>
      </div>
      <Help />
    </div>
  )
}

export default HelpDesk
